/**
 * pre202: Gemeinsames Aufzeichnungs-Modal (Consent + Themenauswahl). 1:1 aus der
 * Berater-InCall extrahiert, damit A/V-Sitzung und Companion optisch/inhaltlich/
 * funktional identisch sind. Rein präsentational + prop-getrieben.
 */

export interface ConsentTopic { id: string; label: string; consentMode?: 'hinweis' | 'einwilligung' }

interface RecordingConsentModalProps {
  open: boolean;
  phase: 'select' | 'waiting' | 'declined';
  topic: string;
  topics: ConsentTopic[];
  onSelectTopic: (id: string) => void;
  onRequestConsent: () => void;
  onCancel: () => void;
  onCancelWaiting: () => void;
  onClose: () => void;
}

export function RecordingConsentModal(props: RecordingConsentModalProps) {
  const { open, phase, topic, topics, onSelectTopic, onRequestConsent, onCancel, onCancelWaiting, onClose } = props;
  if (!open) return null;
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: '#fff', color: '#111', borderRadius: 14, padding: '26px 28px',
        width: 'min(440px, 92vw)', boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
      }}>
        <h3 style={{ margin: '0 0 6px', fontSize: 19 }}>Gespräch aufzeichnen</h3>

        {phase === 'select' && (<>
          <p style={{ margin: '0 0 16px', fontSize: 13.5, lineHeight: 1.55, opacity: 0.8 }}>
            Die Aufzeichnung ist nur für beratungspflichtige Themen zulässig. Die
            Zustimmung wird aktiv auf der Stele eingeholt — der Gast bestätigt per
            Fingertipp und sieht während der gesamten Aufzeichnung einen Hinweis.
          </p>
          <label style={{ display: 'block', fontSize: 12.5, fontWeight: 600, marginBottom: 6 }}>Beratungsthema</label>
          <select
            value={topic}
            onChange={(e) => onSelectTopic(e.target.value)}
            style={{ width: '100%', padding: '9px 10px', borderRadius: 8, border: '1px solid #ccc', marginBottom: 20, fontSize: 14 }}
          >
            {topics.map((t) => (
              <option key={t.id} value={t.id}>{t.label} · {t.consentMode === 'hinweis' ? 'Hinweis' : 'Einwilligung'}</option>
            ))}
          </select>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <button onClick={onCancel}
              style={{ padding: '9px 16px', borderRadius: 8, border: '1px solid #ccc', background: '#f5f5f5', fontSize: 14, cursor: 'pointer' }}>
              Abbrechen
            </button>
            <button onClick={onRequestConsent}
              style={{ padding: '9px 18px', borderRadius: 8, border: 'none', fontSize: 14, fontWeight: 600, background: '#dc2626', color: '#fff', cursor: 'pointer' }}>
              Zustimmung einholen
            </button>
          </div>
        </>)}

        {phase === 'waiting' && (<>
          <p style={{ margin: '0 0 20px', fontSize: 14, lineHeight: 1.55 }}>
            Warte auf die Zustimmung des Gastes auf der Stele …
          </p>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <button onClick={onCancelWaiting}
              style={{ padding: '9px 16px', borderRadius: 8, border: '1px solid #ccc', background: '#f5f5f5', fontSize: 14, cursor: 'pointer' }}>
              Abbrechen
            </button>
          </div>
        </>)}

        {phase === 'declined' && (<>
          <p style={{ margin: '0 0 20px', fontSize: 14, lineHeight: 1.55 }}>
            Der Gast hat die Aufzeichnung abgelehnt. Es wird nichts aufgezeichnet.
          </p>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <button onClick={onClose}
              style={{ padding: '9px 18px', borderRadius: 8, border: 'none', fontSize: 14, fontWeight: 600, background: '#111', color: '#fff', cursor: 'pointer' }}>
              Schließen
            </button>
          </div>
        </>)}
      </div>
    </div>
  );
}
